import * as api from "../../api";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import PaystackLogo from "./SVG/PaystackLogo";
import PaypalLogo from "./SVG/PaypalLogo";
import FlutterwaveLogo from "./SVG/FlutterwaveLogo";

import { KeyboardArrowDown } from "@material-ui/icons";

import { ALERT } from "../../constants/actionTypes";

import Signin from "../../components/Modals/Signin";
import Invoice from "../../components/Invoice/Invoice";

import Prices from "../../utils/prices";

import Paystack from "../../gateways/Paystack";
import Paypal from "../../gateways/Paypal";
import Flutterwave from "../../gateways/Flutterwave";

import Logo from "../../images/logo.svg";

import "./Payment.css";

const Payment = ({ match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [quote, setQuote] = useState();
  const [loading, setLoading] = useState(true);
  const [showSignin, setShowSignin] = useState(false);
  const id = quote?.id;
  const email = quote?.email;
  const amount = Prices(
    quote?.price,
    quote?.totalPages > 0 ? quote?.totalPages : quote?.totalCount,
    quote?.languageTo.length,
    quote?.urgent,
    quote?.addson,
    0.11
  );

  const projectName = quote?.projectName;
  const urgent = quote?.urgent;

  const handleError = useCallback(
    (message) => {
      history.replace("/quote");
      dispatch({
        type: ALERT,
        payload: { severity: "error", message, duration: 5000, display: true },
      });
    },
    [dispatch, history]
  );

  useEffect(() => {
    const fetchQuote = async () => {
      try {
        const { data } = await api.getOneQuote({ _id: match.params.id });
        if (!data) handleError("No project to activate");
        if (data.status === "active") handleError("Project already activated");
        setQuote(data);
      } catch (error) {
        if (error.response) handleError("No project to activate");
        else handleError("Unexpected error occurred");
      }
    };

    if (!localStorage.getItem("auth")) setShowSignin(true);
    else {
      fetchQuote();
      setLoading(false);
    }
  }, [match, showSignin, handleError]);

  return (
    <>
      <Signin showSignin={showSignin} setShowSignin={setShowSignin} payment />
      {(loading || !quote) && (
        <div className="payement__overlay position-fixed t-0 d-flex align-center justify-center w-100 h-100 z-4">
          <div className="spin-large"></div>
        </div>
      )}
      <div className="payment d-flex">
        <div className="payment__left">
          <div className="payment__top d-flex justify-between align-center py-20">
            <img
              src={Logo}
              alt=""
              className="pointer"
              onClick={() => history.push("/")}
            />
            <button className="border-1 outline-0 py-10 px-20 mr-40 rounded pointer">
              Contact Us
            </button>
          </div>
          {quote && (
            <details className="order__details">
              <summary className="d-flex align-center justify-between list-none w-100 border-1 p-10 mt-10">
                Show order summary
                <KeyboardArrowDown />
              </summary>
              <div>
                <Invoice uploadQuote={quote} uncountedFiles={0} payment small />
              </div>
            </details>
          )}
          <div className="payment__bottom d-flex flex-column align-center justify-center m-auto p-40">
            <h2 className="font-subhead">Payment Gateways</h2>
            <p>Choose your preferrable medium of payment</p>

            <div className="payment__grid grid c-3 gap-20 w-100 mt-40">
              <div className="d-flex flex-column align-center border-1 rounded">
                <div className="p-20 border-bottom-1 w-100">
                  Pay with <span className="font-bolder">PayStack</span>
                </div>
                <div className="payment__paystack d-flex flex-column align-center w-100 p-40">
                  <PaystackLogo />
                  <Paystack
                    id={id}
                    email={email}
                    price={amount.total}
                    urgent={urgent}
                  />
                </div>
              </div>
              <div className="d-flex flex-column align-center border-1 rounded">
                <div className="p-20 border-bottom-1 w-100">
                  Pay through <span className="font-bolder">FlutterWave</span>
                </div>
                <div className="payment__flutterwave d-flex flex-column align-center w-100 p-40">
                  <FlutterwaveLogo />
                  <Flutterwave
                    id={id}
                    email={email}
                    price={amount.total}
                    projectName={projectName}
                    urgent={urgent}
                  />
                </div>
              </div>
              <div className="d-flex flex-column align-center border-1 rounded">
                <div className="p-20 border-bottom-1 w-100">
                  Pay with <span className="font-bolder">PayPal</span>
                </div>
                <div className="payment__paypal d-flex flex-column align-center w-100 p-40">
                  <PaypalLogo />
                  <div
                    style={{
                      height: "40px",
                      width: "100%",
                    }}
                  ></div>
                  <Paypal
                    id={id}
                    price={amount.total}
                    projectName={projectName}
                    urgent={urgent}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {quote && <Invoice uploadQuote={quote} uncountedFiles={0} payment />}
      </div>
    </>
  );
};

export default Payment;
